<template>
    <div class="MemberAreaContent__right" :class="{'is-open': isOpen}">
        <div class="UserAlerts">
            <div class="UserAlerts__head">
                <button class="UserAlerts__head-back" @click.prevent="$emit('close')">
                    <i class="fas fa-chevron-left"></i>
                </button>
                <h3 class="UserAlerts__head-title">Informations</h3>
            </div>
            <div v-if="loading && alerts.length < 1" class="UserAlerts__loader">
                <i class="fas fa-spinner fa-spin"></i>
            </div>
            <ul class="UserAlerts__list">
                <Alert v-for="alert in alerts" :alert="alert"/>
            </ul>
        </div>
    </div>
</template>

<script>
    import {actions, getters} from "../../store";
    import {formatDate} from "../../utils";
    import Alert from "./Alert";

    export default {
        components: {Alert},
        props: ['isOpen'],
        data: function () {
            return {
                loading: false
            }
        },
        computed: {
            alerts: getters.alerts
        },
        methods: {
            formatDate
        },
        async created() {
            this.loading = true;
            await actions.fetchAlerts();
            this.loading = false;
        }
    }
</script>
